import OneSignal from 'react-onesignal';
import { registerOnesignalUser } from '../Services/Events.services';

export default async function runOneSignal(phone) {
    const { REACT_APP_ONE_SIGNAL_APP_ID } = process.env;
    try {
        await OneSignal.init({
            appId: REACT_APP_ONE_SIGNAL_APP_ID,
            allowLocalhostAsSecureOrigin: true,
            autoRegister: false,
            subdomainName: 'kleenhub',
            notifyButton: {
                enable: true,
            },
        });

        // Show the prompt for notifications
        await OneSignal.showSlidedownPrompt();

        // Check if push notifications are enabled
        const isPushEnabled = await OneSignal.isPushNotificationsEnabled();

        if (isPushEnabled) {
            // Fetch the user's OneSignal userId
            const userId = await OneSignal.getUserId();

            // Register the user's OneSignal information
            await registerOnesignalUser({
                phone,
                onesignalUserId: userId,
                permissionGranted: true,
            });
        }

        // Listen for subscription changes
        OneSignal.on('subscriptionChange', async (isSubscribed) => {
            if (isSubscribed) {
                const userId = await OneSignal.getUserId();
                await registerOnesignalUser({
                    phone,
                    onesignalUserId: userId,
                    permissionGranted: true,
                });
            }
        });

        // Listen for notification permission changes
        OneSignal.on('notificationPermissionChange', async (permissionChange) => {
            const currentPermission = permissionChange.to;
            const userId = await OneSignal.getUserId();
            await registerOnesignalUser({
                phone,
                onesignalUserId: userId,
                permissionGranted: currentPermission === 'granted',
            });
        });
    } catch (error) {
        console.error(error);
    }
}
